import type { ChangeEvent, FC } from "react";

import { TextareaInputStyle } from "../../../../documentation/styles/InputStyle";
import type { FormInputProps } from "../../types/types";

/**
 * Defines how many rows (height) have the Textarea components by default.
 * This value can be override by using the field properties defined in the json file.
 */
interface TextareaProps extends FormInputProps<string> {
    readOnly: boolean;
    onBlur?: () => void;
}

export const Textarea: FC<TextareaProps> = ({ onChange, readOnly, onBlur, ...rest }) => {
    const onValueChange = (ev: ChangeEvent<HTMLTextAreaElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    return (
        <TextareaInputStyle
            className={readOnly ? "aevi-input aevi-input-textarea aevi-input-disabled" : "aevi-input aevi-input-textarea"}
            disabled={readOnly}
            onChange={onValueChange}
            onBlur={onBlur}
            {...rest}
        />
    );
};
